export default {
  essleaveTotal(state, total) {
    return (state.essleaveTotal = total);
  },
  totalLeaveApprover(state, total) {
    return (state.totalLeaveApprover = total);
  },
  leaveTypes(state, value) {
    return (state.leaveTypes = value);
  },
  searchQuery(state, value) {
    return (state.searchQuery = value);
  },
  tableLoader(state, value) {
    return (state.tableLoading = value);
  },
  currentPage(state, value) {
    return (state.currentPage = value);
  },
  perPage(state, value) {
    return (state.perPage = value);
  },
  currentApprovalPage(state, value) {
    return (state.currentApprovalPage = value);
  },
  perPageApproval(state, value) {
    return (state.perPageApproval = value);
  },
  employees(state, value) {
    return (state.employees = value);
  },
  leavesData(state, value) {
    return (state.leavesData = value);
  },
  currentLeave(state, value) {
    return (state.currentLeave = value);
  },
  employeeLeave(state, value) {
    return (state.employeeLeave = value);
  },
  approvals(state, value) {
    return (state.approvals = value);
  },
  currentApproval(state, value) {
    return (state.currentApproval = value);
  },
  filterLeaveTypes(state, value) {
    return (state.filterLeaveTypes = value);
  },
  filterValue(state, value) {
    return (state.filterValue = value);
  },
};
